export enum ClinType {
  Cost = "COST",
  Fee = "FEE",
  TandM = 'TIME_AND_MATERIAL',
  FixedPrice = 'FIXED_PRICE'
}
